import { create } from 'zustand';
import { SiteModeData, ReadinessData, SiteMode } from '../types/mode.types';

interface ModeStore {
  // Current mode data
  modeData: SiteModeData | null;
  readinessData: ReadinessData | null;
  
  // Loading states
  isLoadingMode: boolean;
  isLoadingReadiness: boolean;
  
  // Errors
  modeError: string | null;
  readinessError: string | null;
  
  // Actions
  setModeData: (data: SiteModeData | null) => void;
  setReadinessData: (data: ReadinessData | null) => void;
  setLoadingMode: (isLoading: boolean) => void;
  setLoadingReadiness: (isLoading: boolean) => void;
  setModeError: (error: string | null) => void;
  setReadinessError: (error: string | null) => void;
  clearMode: () => void;
  
  // Computed getters
  isEarlyStageMode: () => boolean;
  isPerformanceMode: () => boolean;
  hasMinimalData: () => boolean;
}

export const useModeStore = create<ModeStore>((set, get) => ({
  // Initial state
  modeData: null,
  readinessData: null,
  isLoadingMode: false,
  isLoadingReadiness: false,
  modeError: null,
  readinessError: null,

  // Actions
  setModeData: (data) => set({ modeData: data, modeError: null }),
  setReadinessData: (data) => set({ readinessData: data, readinessError: null }),
  setLoadingMode: (isLoading) => set({ isLoadingMode: isLoading }),
  setLoadingReadiness: (isLoading) => set({ isLoadingReadiness: isLoading }),
  setModeError: (error) => set({ modeError: error }),
  setReadinessError: (error) => set({ readinessError: error }),
  clearMode: () => set({
    modeData: null,
    readinessData: null,
    modeError: null,
    readinessError: null
  }),

  // Computed getters
  isEarlyStageMode: () => {
    const { modeData } = get();
    return modeData?.mode === SiteMode.EARLY_STAGE;
  },

  isPerformanceMode: () => {
    const { modeData } = get();
    return modeData?.mode === SiteMode.PERFORMANCE;
  },

  hasMinimalData: () => {
    const { modeData } = get();
    if (!modeData) return true;
    return modeData.totalClicks < 100 || modeData.gscDataDays < 30;
  }
}));
